angular.module('picmonic-common').factory('SalesforceChatService', [
  function () {
    return {
      setUserInfo: function (user) {
        var initESW = function (gslbBaseURL) {
          embedded_svc.settings.displayHelpButton = true; //Or false
          embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'
          embedded_svc.settings.defaultMinimizedText = 'Contact Us'; //(Defaults to Chat with an Expert)
          embedded_svc.settings.disabledMinimizedText = 'Contact Us'; //(Defaults to Agent Offline)
          //embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
          embedded_svc.settings.storageDomain = 'picmonic.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)
          // Settings for Chat
          //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
          // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
          // Returns a valid button ID.
          //};
          //embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
          //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
          embedded_svc.settings.offlineSupportMinimizedText = 'Contact Us'; //(Defaults to Contact Us)

          embedded_svc.settings.enabledFeatures = ['LiveAgent'];
          embedded_svc.settings.entryFeature = 'LiveAgent';

          if (user.user_id) {
            //Sets the auto-population of pre-chat form fields
            embedded_svc.settings.prepopulatedPrechatFields = {
              FirstName: user.first_name,
              LastName: user.last_name,
              Email: user.email,
              Phone: String(user.phone),
              //ProgramName: user.school.name,
            };

            embedded_svc.settings.extraPrechatFormDetails = [
              {
                label: 'First Name',
                name: 'FirstName',
                value: user.first_name,
                displayToAgent: true,
              },
              {
                label: 'Last Name',
                value: user.last_name,
                displayToAgent: true,
              },
              {
                label: 'Email',
                value: user.email,
                displayToAgent: true,
              },
            ];
          }

          embedded_svc.settings.extraPrechatInfo = [
            {
              entityName: 'Contact',
              showOnCreate: true,
              linkToEntityName: 'Case',
              linkToEntityField: 'ContactId',
              saveToTranscript: 'ContactId',
              entityFieldMaps: [
                {
                  isExactMatch: true,
                  fieldName: 'Email',
                  doCreate: false,
                  doFind: true,
                  label: 'Email',
                },
              ],
            },
            {
              entityName: 'Case',
              showOnCreate: true,
              saveToTranscript: 'CaseId',
              entityFieldMaps: [
                {
                  isExactMatch: false,
                  fieldName: 'Subject',
                  doCreate: true,
                  doFind: false,
                  label: 'issue',
                },
                {
                  isExactMatch: false,
                  fieldName: 'Status',
                  doCreate: true,
                  doFind: false,
                  label: 'Status',
                },
                {
                  isExactMatch: false,
                  fieldName: 'Origin',
                  doCreate: true,
                  doFind: false,
                  label: 'Origin',
                },
              ],
            },
          ];

          embedded_svc.init(
            'https://truelearn.my.salesforce.com',
            'https://truelearn.my.salesforce-sites.com/livesupportchat',
            gslbBaseURL,
            '00Dd0000000eS9Y',
            'PICM_Website_New',
            {
              baseLiveAgentContentURL: 'https://c.la4-c2-ia4.salesforceliveagent.com/content',
              deploymentId: '5720W00000158L1',
              buttonId: '5736T000001l5n6',
              baseLiveAgentURL: 'https://d.la4-c2-ia4.salesforceliveagent.com/chat',
              eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000wk33UAA_181b65339ad',
              isOfflineSupportEnabled: true,
            }
          );
        };
        if (!window.embedded_svc) {
          var s = document.createElement('script');
          s.setAttribute('src', 'https://truelearn.my.salesforce.com/embeddedservice/5.0/esw.min.js');
          s.onload = function () {
            initESW(null);
          };
          document.body.appendChild(s);
        } else {
          initESW('https://service.force.com');
        }
      },
      startChat: function (message) {
        embedded_svc.settings.prepopulatedPrechatFields = Object.assign(
          embedded_svc.settings.prepopulatedPrechatFields ?? {},
          {
            Subject: message,
          }
        );

        document.getElementById('helpButtonSpan').click();
      },
    };
  },
]);
